import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetHelpList } from "../service";

export const useGetHelpList = (options) => {
  return useQuery(
    [queryKey.HELP_LIST],
    () => apiGetHelpList().then((res) => res.data.data),
    {
      ...options,
    }
  );
};
